var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7647 16.9175L39.5588 16.0616H20.5882V23.9384H31.9216C30.7451 29.4205 25.2843 32.3058 20.8235 32.3058C17.5784 32.3058 14.1569 30.969 11.8922 28.8146C9.56863 26.6025 8.08824 23.3421 8.08824 19.9856C8.08824 16.6675 9.60784 13.3494 11.8235 11.1661C14.0294 8.99255 17.3725 7.76148 20.6961 7.76148C24.5 7.76148 27.2255 9.74273 28.2451 10.6468L33.951 5.07814C32.2745 3.63549 27.6765 0 20.5098 0C14.9804 0 9.67647 2.07742 5.80392 5.86679C1.98039 9.59846 0 14.994 0 19.9952C0 24.9964 1.87255 30.1322 5.57843 33.8928C9.53922 37.9033 15.1471 40 20.9216 40C26.1765 40 31.1569 37.9803 34.7059 34.3159C38.1961 30.7093 40 25.7177 40 20.4857C40 18.2832 39.7745 16.9752 39.7647 16.9175Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Google.4310d1030b40c64029ffdb814f153faa.svg";